import React from 'react';
import MaterialIcon from 'material-icons-react';
import './StepCounter.css';

export default class StepCounter extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>

        <div className='row'>

          <div className='col s4 m4 l4 StepIcon'>
            <MaterialIcon icon="work"/>
          </div>

          <div className='col s8 m8 l8'>
            Você está na etapa:
            <h5 className='StepText'>{this.props.step} / {this.props.total}</h5>
          </div>

        </div>
      </div >
    );
  }
};

